import astroPay from 'shared/img/payment/astro-pay.webp'
import bankDetails from 'shared/img/payment/bank-details.webp'
import bankaTransferi from 'shared/img/payment/Banka-Transferi.webp'
import binancePay from 'shared/img/payment/binance-pay.webp'
import bkash from 'shared/img/payment/bkash.webp'
import bkashFree from 'shared/img/payment/bkash-free.webp'
import mobcash from 'shared/img/payment/mobcash.webp'
import nagad from 'shared/img/payment/nagad.webp'
import nagadFree from 'shared/img/payment/nagad-free.webp'
import Papara from 'shared/img/payment/papara.webp'
import Payco from 'shared/img/payment/payco.webp'
import Paypal from 'shared/img/payment/paypal.webp'
import paytm from 'shared/img/payment/paytm.webp'
import rocket from 'shared/img/payment/rocket.webp'
import sipsak from 'shared/img/payment/sipsak.webp'
import surecash from 'shared/img/payment/surecash.webp'
import trc20Usdt from 'shared/img/payment/trc20Usdt.webp'
import upay from 'shared/img/payment/upay.webp'

export const getIconForPayment: Record<string, string> = {
  bkash,
  bkash_free: bkashFree,
  binance_pay: binancePay,
  bank_details: bankDetails,
  astro_pay: astroPay,
  nagad,
  nagad_free: nagadFree,
  upay,
  Paypal,
  sipsak,
  bankaTransferi,
  Papara,
  'Bank Transfer': bankaTransferi,
  surecash_megapari: surecash,
  rocket,
  paytm,
  usdttrc20: trc20Usdt,
  mobcash,
  nowpayments: trc20Usdt,
  Payco,
  default: '',
}

export type paymentNames = keyof typeof getIconForPayment
